import e from "../managers/braze-instance.js";
import { logDeprecationWarning as D } from "../util/deprecation-utils.js";
export function logContentCardsDisplayed() {
  if (e.rr()) return D("logContentCardsDisplayed", "method"), !0;
}
